import type { IngredientId } from '@libs/trip-planner-interfaces';

import type {
  CheckboxFilterData,
  CheckboxUpdateFilterEvent,
  CircularRadioButtonFilterData,
  CircularRadioButtonUpdateFilterEvent,
  RangeSliderFilterData,
  RangeSliderUpdateFilterEvent,
} from '../filters';
import type { SuggestionType } from '../suggestionTypeSelector';

export const enum FerryFilterType {
  ArrivalTime = 'ArrivalTime',
  DepartureTime = 'DepartureTime',
  Carriers = 'Carriers',
  SortBy = 'SortBy',
}

export const enum FerryFiltersEventType {
  UpdateFilter = 'UpdateFilter',
}

export interface Filter<T> {
  filterType: T;
}

export interface ArrivalTimeFilter extends Filter<FerryFilterType> {
  filterType: FerryFilterType.ArrivalTime;
  filters: RangeSliderFilterData[];
  label: string;
}

export interface DepartureTimeFilter extends Filter<FerryFilterType> {
  filterType: FerryFilterType.DepartureTime;
  filters: RangeSliderFilterData[];
  label: string;
}

export interface CarriersFilter extends Filter<FerryFilterType> {
  filterType: FerryFilterType.Carriers;
  label: string;
  data: CarriersFilterData[];
}

export interface SortByFilter extends Filter<FerryFilterType> {
  filterType: FerryFilterType.SortBy;
  filters: CircularRadioButtonFilterData[];
  label: string;
}
interface CarriersFilterData {
  filters: CheckboxFilterData[];
  title: string;
  ingredientId: IngredientId;
}

export interface FerryFilters {
  ingredientId: IngredientId;
  arrivalTime: ArrivalTimeFilter;
  departureTime: DepartureTimeFilter;
  carriers: CarriersFilter;
  sortBy: SortByFilter;
}

interface UpdateFilterEvent<T> {
  eventType: FerryFiltersEventType.UpdateFilter;
  filterType: FerryFilterType;
  data: T;
}

export interface ArrivalTimeUpdateFilterEvent
  extends UpdateFilterEvent<RangeSliderUpdateFilterEvent> {
  eventType: FerryFiltersEventType.UpdateFilter;
  filterType: FerryFilterType.ArrivalTime;
}

export interface CarriersFilterUpdateFilterEvent
  extends UpdateFilterEvent<CheckboxUpdateFilterEvent> {
  eventType: FerryFiltersEventType.UpdateFilter;
  filterType: FerryFilterType.Carriers;
}

export interface DepartureTimeUpdateFilterEvent
  extends UpdateFilterEvent<RangeSliderUpdateFilterEvent> {
  eventType: FerryFiltersEventType.UpdateFilter;
  filterType: FerryFilterType.DepartureTime;
}

export interface SortByUpdateFilterEvent
  extends UpdateFilterEvent<CircularRadioButtonUpdateFilterEvent> {
  eventType: FerryFiltersEventType.UpdateFilter;
  filterType: FerryFilterType.SortBy;
  selected: SuggestionType;
}

export type FerryFilterEvents =
  | ArrivalTimeUpdateFilterEvent
  | DepartureTimeUpdateFilterEvent
  | CarriersFilterUpdateFilterEvent
  | SortByUpdateFilterEvent;

export const enum FiltersPanelEventType {
  CloseFiltersPanel = 'CloseFiltersPanel',
}

export interface FiltersPanelEvent {
  eventType: FiltersPanelEventType.CloseFiltersPanel;
}

export type FiltersPanelEvents = FiltersPanelEvent | FerryFilterEvents;
